





























import { Component, Watch } from 'vue-property-decorator'
import { WebhooksModule } from '@/store/Settings/WebhooksModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import Webhook from '@/models/Settings/Webhooks/Webhook';
import WebhookCreate from '@/components/Settings/Webhooks/WebhookCreate.vue';
import WebhookPublicKey from '@/components/Settings/Webhooks/WebhookPublicKey.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'WebhooksList', components: { Alert, WebhookCreate, WebhookPublicKey }, metaInfo: { title: 'Webhooks' } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    headers = [
        { text: this.$t('pageText.webhooks.fields.name'), sortable: false, width: '30%' },
        { text: this.$t('pageText.webhooks.fields.eventType'), sortable: false, width: '30%' },
        { text: this.$t('pageText.webhooks.fields.url'), sortable: false, width: '30%' },
        { text: this.$t('pageText.webhooks.fields.enabled'), sortable: false, width: '10%' }
    ];
    webhooksPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.webhooksPage = +page;
        }
    }

    async beforeMount() {
        await WebhooksModule.getWebhooks(this.webhooksPage);
    }

    get webhooks() {
        return WebhooksModule.webhooks;
    }

    get totalWebhooksPages() {
        return WebhooksModule.totalWebhooksPages;
    }

    get loading() {
        return WebhooksModule.loadingWebhooks;
    }

    get pageSize() {
        return WebhooksModule.pageSize;
    }

    @Watch('webhooksPage')
    async onWebhooksPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.webhooksPage}` } });
        // Get new webhooks
        await WebhooksModule.getWebhooks(this.webhooksPage);
    }

    async navigateToWebhook(webhook: Webhook) {
        this.$router.push({ name: PageNames.Webhook, params: { id: webhook.id }, query: { tab: "0" } });
    }

}
